import { render, staticRenderFns } from "./PaymentTypeSegmentations.vue?vue&type=template&id=3a5c3bc1"
import script from "./PaymentTypeSegmentations.vue?vue&type=script&lang=js"
export * from "./PaymentTypeSegmentations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports